<template>
  <div>
    <Header :logged="checkIfUserIsLogged"/>
    <div class="content-wrapper-component">
      <router-view></router-view>
    </div>
    <Footer/>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import 'hideseek'
import Header from '../components/Header'
import UserStore from '../../store/user-store'
import Footer from '../components/Footer'

export default {
  name: 'Dash',
  components: {
    Footer,
    Header
  },
  data: function () {
    return {
      error: '',
      logged: false
    }
  },
  computed: {
    ...mapState([
      'userInfo'
    ]),
    demo() {
      return {
        displayName: this.$store.state.user,
        avatar: window.localStorage.getItem('picture'),
        email: this.$store.state.email
      }
    },
    checkIfUserIsLogged() {
      this.logged = UserStore.logged
      return this.logged
    }
  },
  beforeMount() {
    UserStore.logged = true
  },
  methods: {
    changeloading() {
      this.$store.commit('TOGGLE_SEARCHING')
    },
    logout() {
      UserStore.logged = false
      this.$store.commit('SET_USER', null)
      this.$store.commit('SET_TOKEN', null)
      if (window.localStorage) {
        window.localStorage.setItem('user', null)
        window.localStorage.setItem('token', null)
        window.localStorage.setItem('picture', null)
        window.localStorage.setItem('refresh_token', null)
        window.localStorage.setItem('role', null)
        window.localStorage.setItem('count', null)
      }
      this.$router.push('/biomanager/login')
    }
  }
}
</script>

<style>
.content-wrapper-component {
  min-height: calc(100vh - 146px);
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// Home.vue?2dbf272c